export default __webpack_public_path__ + "static/media/film.03d58d9c.png";